export default __webpack_public_path__ + "static/media/gold-edit-icon.5a702675.svg";